import { DummyStore } from 'stores';

import { TransactionResponse } from '../types';

export const couponStore = new DummyStore<CouponType>();
export const couponOrdersStore = new DummyStore<TransactionResponse>();
